import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsFindBy } from 'services/WService.js';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [tipoIncentivo, setTipoIncentivo] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listTipoIncentivo() {
    let response = await wsFindBy('sale/tipo-incentivo');
    if (response.success) setTipoIncentivo(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (bPartnerSelect?.CodigoCategoria) {
      setDataChanging((prev) => ({
        ...prev,
        CodigoCategoria: bPartnerSelect?.CodigoCategoria || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {listTipoIncentivo();};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Nuevo grupo de incentivos`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={'sale/grupo-incentivo'}
        dataForce={{
          tipo_incentivo_id: dataChanging.tipo_incentivo_id,
        }}
      >
        <>
          <TextField
            label="Periodo"
            fullWidth
            type="month"
            name="periodo"
            margin="normal"
            defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
            InputLabelProps={{ shrink: true }}
            inputProps={{ readOnly: true }}
            required
          />
          <Autocomplete
            disableClearable
            options={tipoIncentivo}
            getOptionLabel={(item) => `${item.description}`}
            renderInput={(params) => (
              <TextField {...params} label="Tipo Incentivo" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('tipo_incentivo_id', item?.id);}}
            value={tipoIncentivo.find((incentivo) => incentivo.id === dataChanging.tipo_incentivo_id) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <TextField
            label="Código"
            fullWidth
            type="text"
            name="code"
            margin="normal"
            value={dataChanging.code || ''}
            onChange={(e) => handleChange('code', e.target.value)}
            required
          />
          <TextField
            label="Descripción"
            fullWidth
            type="text"
            name="description"
            margin="normal"
            value={dataChanging.description || ''}
            onChange={(e) => handleChange('description', e.target.value)}
            required
          />
        </>
      </Modal>
    </>
  );
});
